import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CarrierDto, QuoteModel, ShipViaDto } from "@insite/client-framework/Types/ApiModels";
import { CustomHandler } from "@tJohnstonCompanies/Handlers/CustomHandlerCreator";

type HandlerType = CustomHandler<{ carrier?: CarrierDto; iseditable?: boolean }>;

export const DispatchSetCarrier: HandlerType = props => {
    props.dispatch({
        type: "Custom/RfqQuoteDetailsNew/SetCarrier",
        carrier: props.parameter.carrier,
        iseditable: props.parameter.iseditable,
    });
};

export const chain = [DispatchSetCarrier];

const setCarrier = createHandlerChainRunner(chain, "SetCarrier");
export default setCarrier;
